(function () {
  'use strict';

  var COLORS = ['#d5f672', '#1b3246', '#ffffff', '#c5e85a', '#2a4560'];

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function burst(options) {
    if (prefersReducedMotion()) return;

    var opts = options || {};
    var particleCount = opts.particleCount || 70;
    var spread = opts.spread || 72;
    var startVelocity = opts.startVelocity || 42;
    var origin = opts.origin || { x: 0.5, y: 0.35 };
    var duration = opts.duration || 1800;

    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText =
      'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:99999';
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);

    function resize() {
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    resize();

    var ox = origin.x * window.innerWidth;
    var oy = origin.y * window.innerHeight;
    var spreadRad = (spread * Math.PI) / 180;
    var particles = [];

    for (var i = 0; i < particleCount; i++) {
      var angle = -Math.PI / 2 + (Math.random() - 0.5) * spreadRad;
      var velocity = startVelocity * (0.55 + Math.random() * 0.75);

      particles.push({
        x: ox,
        y: oy,
        vx: Math.cos(angle) * velocity,
        vy: Math.sin(angle) * velocity,
        w: 6 + Math.random() * 6,
        h: 4 + Math.random() * 5,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        rotation: Math.random() * Math.PI,
        spin: (Math.random() - 0.5) * 0.25,
        gravity: 0.35 + Math.random() * 0.15,
        drag: 0.96 + Math.random() * 0.02
      });
    }

    var start = performance.now();

    function frame(now) {
      var elapsed = now - start;
      var life = 1 - elapsed / duration;

      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

      if (life <= 0) {
        canvas.remove();
        return;
      }

      for (var j = 0; j < particles.length; j++) {
        var p = particles[j];

        p.vx *= p.drag;
        p.vy *= p.drag;
        p.vy += p.gravity;
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.spin;

        ctx.save();
        ctx.globalAlpha = Math.max(life, 0);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }

      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function burstFromElement(el, options) {
    if (!el || !el.getBoundingClientRect) {
      burst(options);
      return;
    }

    var rect = el.getBoundingClientRect();
    var opts = options || {};
    opts.origin = {
      x: (rect.left + rect.width / 2) / window.innerWidth,
      y: (rect.top + rect.height / 2) / window.innerHeight
    };
    burst(opts);
  }

  window.RabitatConfetti = {
    burst: burst,
    burstFromElement: burstFromElement
  };
})();
